var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 354.331 215.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-492.254 -3688.394)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-352 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M376.675,461.547V307.035a8.367,8.367,0,0,0-8.5-8.5h-248.4a8.367,8.367,0,0,0-8.5,8.5V461.917H83.911v9.98c3.7,5.913,23.289,9.241,30.681,9.241H372.976c7.763,0,27.354-3.7,30.681-9.241v-9.98H376.675v-.37ZM116.92,307.035H371.18V461.917l-254.26-.37Z",
    transform: "translate(760.343 3392.863)",
    fill: "#411fd1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 252,
    height: 154,
    transform: "translate(878 3700)",
    fill: "#050314"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-265 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.683,434.824V305.641a7,7,0,0,0-7.109-7.11H113.89a7,7,0,0,0-7.109,7.11V435.133H83.911v8.344c3.092,4.944,19.471,7.726,25.652,7.726H325.591c6.49,0,22.87-3.091,25.652-7.726v-8.344H328.683v-.309ZM111.509,305.641h212.58V435.133l-212.58-.309Z",
    transform: "translate(760.343 3392.863)",
    fill: "#411fd1"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 128,
    transform: "translate(872 3699)",
    fill: "#050314"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.ffe737c8.svg";
export { ForwardRef as ReactComponent };